<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MenuCard :menuItems="menuItems" />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import MenuCard from "@/components/MenuCard";

export default {
    page: {
        title: i18n.t("module.vehicle"),
    },
    components: { Layout, PageHeader, MenuCard },
    data() {
        return {
            title: i18n.t("module.vehicle"),
            items: [
                {
                    text: i18n.t("module.vehicle"),
                    active: true,
                },
            ],
            menuItems: [
                {
                    route: 'Panels',
                    label: i18n.t('module.panel'),
                    icon: 'mdi-table-large',
                    color: 'info',
                    core: true,
                },
                {
                    route: 'PanelType',
                    label: i18n.t('module.panelType'),
                    icon: 'mdi-shape-outline',
                    color: 'primary',
                    core: false,
                },
            ],
        };
    },
}
</script>